import { QUICK_SIGN_TEXT } from "@src/appV2/redesign/Documents/DocumentsPage/constants";
import { Pill } from "@src/appV2/redesign/system/ui-components";

export function QuickSignPill() {
  return (
    <Pill
      size="medium"
      label={QUICK_SIGN_TEXT}
      backgroundColor={(theme) => theme.palette.intent?.success.background}
      color={(theme) => theme.palette.intent?.success.text}
      iconColor={(theme) => theme.palette.intent?.success.icon}
    />
  );
}
